import { ChevronRightIcon, HomeIcon } from "@heroicons/react/solid";
import Head from "next/head";
import Link from "next/link";
import { ReactNode } from "react";
import { Avatar } from "./avatar";

export const Blog = ({
  title,
  tags,
  author,
  children,
}: {
  title: string;
  tags: string[];
  author: string;
  children: ReactNode;
}) => {
  return (
    <>
      <Head>
        <title>{`${title} | Blog | Find Free Online Courses | classhubs`}</title>
      </Head>
      <div className="max-w-4xl mx-auto pt-40 px-4 py-10 md:px-24 flex flex-col gap-y-2">
        <div className="flex" aria-label="Breadcrumb">
          <ol role="list" className="flex items-center space-x-2">
            <li>
              <div>
                <Link href="/" className="text-gray-400 hover:text-gray-500">
                  <HomeIcon
                    className="flex-shrink-0 h-5 w-5"
                    aria-hidden="true"
                  />
                  <span className="sr-only">Home</span>
                </Link>
              </div>
            </li>
            <li>
              <div className="flex items-center">
                <ChevronRightIcon
                  className="flex-shrink-0 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
                <Link
                  href={{ pathname: "/blog/page/[page]", query: { page: "1" } }}
                  className="ml-2 text-sm font-medium text-gray-500 hover:text-gray-700"
                >
                  Blog
                </Link>
              </div>
            </li>
            <li>
              <div className="flex items-center">
                <ChevronRightIcon
                  className="flex-shrink-0 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
                <Link
                  href="#"
                  className="ml-2 text-sm font-medium text-gray-500 hover:text-gray-700"
                >
                  {title}
                </Link>
              </div>
            </li>
          </ol>
        </div>
        <div className="prose">
          <h1 className="text-2xl font-extrabold">{title}</h1>
        </div>
        <div className="flex gap-x-2 items-center">
          <Avatar name={author} photo={null} className="h-8 w-8" />
          <span className="italic">{author}</span>
        </div>
        <div className="flex gap-x-2 prose">
          {tags.map((tag) => (
            <span
              key={tag}
              className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800"
            >
              <svg
                className="mr-1.5 h-2 w-2 text-gray-400"
                fill="currentColor"
                viewBox="0 0 8 8"
              >
                <circle cx={4} cy={4} r={3} />
              </svg>
              {tag}
            </span>
          ))}
        </div>
        <div className="prose">
          <p className="text-xl font-semibold">
            Find the perfect online course for you right now with{" "}
            <Link href={{ pathname: "/" }}>Classhubs</Link>!
          </p>
          {children}
          <p className="text-xl font-semibold">
            Find the perfect online course for you right now with{" "}
            <Link href={{ pathname: "/" }}>Classhubs</Link>!
          </p>
        </div>
      </div>
    </>
  );
};
